var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loader)?_c('app-overlay-loader'):_c('app-leave-summary',{attrs:{"first-user":JSON.stringify(_vm.employee),"specific":true,"manager-dept":this.props.managerDept,"from-employee-details":true}})}
var staticRenderFns = []

export { render, staticRenderFns }